import { clsx } from 'clsx'
import { AtLeast, WorkflowRun } from '@basehub/data/replicache/index'
import { ClockIcon, CommitIcon, Pencil1Icon } from '@radix-ui/react-icons'
import { BlockIcon } from '~/components/block-icon'
import { Spinner2 } from '~/components/misc/spinner'

const COLORS: Record<WorkflowRun['status'], Record<'text' | 'bg', string>> = {
  error: { text: 'text-red', bg: 'bg-red/15' },
  stopped: { text: 'text-red', bg: 'bg-red/15' },
  success: { text: 'text-success', bg: 'bg-success/15' },
  pending: { text: 'text-dark-muted', bg: 'bg-dark-muted/15' },
  running: { text: 'text-dark-muted', bg: 'bg-dark-muted/15' },
}

export const WorkflowRunIcon = ({
  run,
  withBg,
  className,
  style,
}: {
  run: AtLeast<WorkflowRun, 'status' | 'trigger'>
  withBg?: true
  className?: string
  style?: React.CSSProperties
}) => {
  const textColor = COLORS[run.status].text
  const bgColor = COLORS[run.status].bg

  if (run.status === 'running') {
    return (
      <span
        style={style}
        className={clsx(
          withBg ? bgColor : '',
          className,
          textColor,
          'flex items-center justify-center rounded size-5'
        )}
      >
        <Spinner2 className="size-[15px]" />
      </span>
    )
  } else if (run.status === 'pending') {
    return (
      <span
        style={style}
        className={clsx(
          withBg ? bgColor : '',
          className,
          textColor,
          'flex items-center justify-center rounded size-5'
        )}
      >
        <ClockIcon />
      </span>
    )
  }

  switch (run.trigger.type) {
    case 'commit.created':
      return (
        <span
          style={style}
          className={clsx(
            withBg ? bgColor : '',
            className,
            textColor,
            'flex items-center justify-center rounded size-5'
          )}
        >
          <CommitIcon />
        </span>
      )
    case 'event-block.created':
      return (
        <span
          style={style}
          className={clsx(
            withBg ? bgColor : '',
            className,
            textColor,
            'flex items-center justify-center rounded size-5'
          )}
        >
          <BlockIcon block={{ type: 'event' }} />
        </span>
      )
    case 'list-block.created':
    case 'list-block.updated':
    case 'list-block.deleted':
      return (
        <span
          style={style}
          className={clsx(
            withBg ? bgColor : '',
            className,
            'flex items-center justify-center rounded size-5'
          )}
        >
          <BlockIcon
            block={{ type: 'list' }}
            iconProps={{ className: textColor }}
          />
        </span>
      )
    case 'block.updated':
    case 'layout-block.updated':
      return (
        <span
          style={style}
          className={clsx(
            withBg ? bgColor : '',
            className,
            'flex items-center justify-center rounded size-5'
          )}
        >
          <Pencil1Icon className={textColor} />
        </span>
      )
    default:
      return null
  }
}
